import React from 'react';

import { Text } from '../../../../../builder-io/storyblocks-design-system/components/atoms/Text/Text';
import Carousel from '../../../../../common/components/Carousel/Carousel';
import CarouselItem from '../../../../../common/components/Carousel/CarouselItem';
import { UseCase } from './utils/constants';

interface UseCaseSelectorProps {
  useCases: UseCase[];
  selectedUseCase: string | null;
  onUseCaseSelect: (id: string) => void;
}

const UseCaseSelector: React.FC<UseCaseSelectorProps> = ({
  useCases,
  selectedUseCase,
  onUseCaseSelect,
}) => {
  const handleUseCaseClick = (useCase: UseCase) => {
    if (onUseCaseSelect) {
      onUseCaseSelect(useCase.id);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent, useCase: UseCase) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleUseCaseClick(useCase);
    }
  };

  return (
    <div className="w-full">
      <Text fontSize="sm">What kind of edit are you going for?</Text>
      <div className="relative mb-6">
        <Carousel
          numberItemsToShow={4}
          sliderButtonBackClassName="-left-12"
          sliderButtonNextClassName="-right-12"
        >
          {useCases.map((useCase) => (
            <CarouselItem key={useCase.id}>
              <div
                role="button"
                tabIndex={0}
                onClick={() => handleUseCaseClick(useCase)}
                onKeyDown={(e) => handleKeyDown(e, useCase)}
                aria-label={`Select ${useCase.title}`}
                className={`border-2 rounded-2.5xl p-3 h-24 mx-1.5 cursor-pointer transition-all focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50 w-full ${
                  selectedUseCase === useCase.id
                    ? 'border-white bg-gray-800'
                    : 'bg-gray-900 border-gray-700 hover:border-gray-600'
                }`}
              >
                <img
                  src={`${__ASSETS_COMMON_IMAGES_URL__}/icons/${useCase.icon}.svg`}
                  alt={useCase.title}
                  className="h-5 w-5 mb-2"
                />
                <Text fontSize="sm" className="my-2">
                  {useCase.title}
                </Text>
              </div>
            </CarouselItem>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default UseCaseSelector;
